import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/_components/MainContent/MainContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/_components/Suggestions/SuggestionList.tsx");
